import React, { useState } from "react";
import Button from '@mui/material/Button';
import ReactPlayer from 'react-player';
import './VideoModal.scss';
import { useHistory } from "react-router-dom";

const VideoModal = () => {

    const [modalOpen, setModalOpen] = useState(false);

    const handleCloseModal = () => {
        setModalOpen(false);
    }
    let history = useHistory();
    const redirect = () => {
        history.push({
            pathname: `/score`,
        })
    }

    return (
        <>
            {(
                <div
                    open={modalOpen}
                    onClose={handleCloseModal}
                    className="video-modal-container">
                    <div className="pop-up-modal-video">
                        <div className="video-modal">
                            <div className="row">
                                <div className="col-1 close-icon offset-11">
                                    <Button className="col" id="redirect-button" onClick={redirect}>
                                        <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                                        </svg></span>
                                    </Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col pt-3">

                                    <ReactPlayer
                                        url='https://youtu.be/TQ3_4xOr-0k'
                                        className='react-player'
                                        controls={true}
                                    />
                                </div>
                                
                            </div>
                            <div className="video-row pt-3">
                            <p>Descubre en este video todas las funcionalidades que te ofrece eGrade.</p>
                            </div>
                        </div>
                    </div>
                </div >
            )}
        </>
    );
}

export default VideoModal;